async function api(path) {
  const res = await fetch(path);
  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    console.error("Spotify API proxy error:", res.status, data);
    throw new Error(data?.error?.message || data?.error || `Spotify API failed: ${res.status}`);
  }

  return data;
}

async function collectPaged(firstPath, getItems = (data) => data.items || [], maxItems = 1000) {
  let path = firstPath;
  const items = [];

  while (path && items.length < maxItems) {
    const data = await api(path);
    items.push(...getItems(data));

    if (!data.next) break;

    const nextUrl = new URL(data.next);
    const spotifyPath = nextUrl.pathname.replace("/v1", "");
    path = `/api/spotify/raw?path=${encodeURIComponent(spotifyPath + nextUrl.search)}`;
  }

  return items.slice(0, maxItems);
}

export const spotifyApi = {
  me: () => api("/api/spotify/me"),

  playlists: async () => ({
    items: await collectPaged("/api/spotify/playlists", (d) => d.items || [], 1000),
  }),

  recentlyPlayed: () =>
    api("/api/spotify/recently-played"),

  topArtists: () =>
    api("/api/spotify/top-artists"),

  topTracks: () =>
    api("/api/spotify/top-tracks"),

  search: (query) =>
    api(`/api/spotify/search?q=${encodeURIComponent(query)}`),

  artistAlbums: (id, group = "album") =>
    api(`/api/spotify/artist/${encodeURIComponent(id)}/albums?group=${encodeURIComponent(group)}`),

  album: (id) =>
    api(`/api/spotify/album/${encodeURIComponent(id)}`),

  nowPlaying: () =>
    api("/api/spotify/now-playing"),

  playbackState: () =>
    api("/api/spotify/playback-state"),

  likedSongs: async () => ({
    items: await collectPaged("/api/spotify/liked-songs", (d) => d.items || [], 1000),
  }),

  savedAlbums: async () => ({
    items: await collectPaged("/api/spotify/saved-albums", (d) => d.items || [], 1000),
  }),

  followedArtists: async () => {
    const data = await api("/api/spotify/followed-artists");
    return { artists: { items: data.artists?.items || [] } };
  },

  playlist: (id) =>
    api(`/api/spotify/playlist/${encodeURIComponent(id)}`),

  playlistTracks: async (id) => ({
    items: await collectPaged(
      `/api/spotify/playlist/${encodeURIComponent(id)}/tracks`,
      (d) => d.items || [],
      1000
    ),
  }),
};
